import { CopyButton, Loader } from "dash-styled"
import { JSONEditor } from "../../../../Common/Lazy/JSONEditor"

interface CodeBlockProps {
    className?: string
    children: unknown
    updateOnChange?: boolean
}

export const CodeBlock = ({
    className,
    children,
    updateOnChange = false
}: CodeBlockProps) => {
    return (
        <div className={`relative flex flex-col group ${className ?? ""}`}>
            <JSONEditor
                className="h-full"
                initialValue={children}
                value={updateOnChange ? children : undefined}
                fallback={<Loader size="xxxl" absolute={true} mask={false} />}
            />
            <CopyButton
                variant="normal"
                value={() => JSON.stringify(children, null, 2)}
                className="absolute z-10 m-3 bottom-0 right-0 bg-white invisible group-hover:visible"
            />
        </div>
    )
}
